<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m1-14a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.5 2.5a1 1 0 0 0 1.414-1.414L13 11.586z"
      fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
